/* eslint-disable react/destructuring-assignment */
// importer la librairie de react

import React, { useEffect, useState } from "react"
import ComponentsUtils from "../../../utils/components"

const StepperItem = (props: {
    activeStep: number
    fields: Array<any>
    index: number
    name: string
    error: boolean
}): React.JSX.Element => {
    // crée la liste des composants présent dans le stepper
    const [components, setComponents] = useState<Array<React.JSX.Element>>([])
    useEffect(() => {
        /* initialisation des composants fils */
        if (props.fields) {
            ComponentsUtils.initChildFieldsComponent(
                props.fields,
                setComponents
            )
        }
    }, [props])
    return <>{props.activeStep === props.index ? components : null}</>
}
export default StepperItem
